export const ASSETS = 'ASSETS'
export const EMAIL = 'EMAIL'
export const HISTORY = 'HISTORY'
export const RELATED_DOCS = 'RELATED_DOCS'
export const RELATED_ATTACHMENTS = 'RELATED_ATTACHMENTS'
export const CHAT = 'CHAT'
export const WORKFLOW = 'WORKFLOW'
export const SYNC_HISTORY = 'SYNC_HISTORY'
export const BUDGET = 'BUDGET'

export const rightPanelViews = Object.freeze({
    assets: {
        key: ASSETS,
        icon: 'fal fa-file-alt',
        tooltip: 'Invoice assets',
        isVisible: true
    },
    budget: {
        key: BUDGET,
        icon: 'fal fa-gauge-simple-high',
        tooltip: 'Budget',
        isVisible: false
    },
    email: {
        key: EMAIL,
        icon: 'fal fa-envelope',
        tooltip: 'Inbox messages',
        isVisible: true
    },
    relatedDocs: {
        key: RELATED_DOCS,
        icon: 'fal fa-sticky-note',
        tooltip: 'Related documents',
        isVisible: true
    },
    relatedAttachments: {
        key: RELATED_ATTACHMENTS,
        icon: 'fal fa-thumbtack',
        tooltip: 'Related attachments',
        isVisible: true
    },
    chat: {
        key: CHAT,
        icon: 'fal fa-comment-alt-lines',
        tooltip: 'Chat',
        isVisible: true
    },
    history: {
        key: HISTORY,
        icon: 'fal fa-clock',
        tooltip: 'History',
        isVisible: true
    },
    syncHistory: {
        key: SYNC_HISTORY,
        icon: 'fal fa-plug',
        tooltip: 'Sync history',
        isVisible: true
    },
    workflow: {
        key: WORKFLOW,
        icon: 'fal fa-network-wired font-13',
        tooltip: 'Workflow history',
        isVisible: true
    }
})
